
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C115.04 0 0 115.049 0 256c0 140.96 115.049 256 256 256 140.96 0 256-115.049 256-256C512 115.04 396.951 0 256 0zM75.299 120.42c25.976 34.848 41.345 76.737 44.208 120.58H30.51c2.967-45.048 19.18-86.534 44.789-120.58zM30.51 271h88.997c-2.86 43.872-18.226 85.733-44.209 120.579C49.69 357.533 33.477 316.048 30.51 271zM241 481.49c-56.822-3.742-107.97-28.571-145.675-66.725 32.285-41.012 51.196-91.172 54.228-143.765H241v210.49zM241 241h-91.448c-3.035-52.558-21.948-102.758-54.223-143.769C133.033 59.079 184.18 34.252 241 30.51V241zm240.49 0h-88.997c2.86-43.872 18.226-85.733 44.209-120.579C462.31 154.467 478.523 195.952 481.49 241zM271 30.51c56.822 3.742 107.97 28.571 145.675 66.725-32.285 41.012-51.196 91.171-54.228 143.765H271V30.51zm0 450.98V271h91.448c3.038 52.522 21.958 102.759 54.223 143.768-37.704 38.153-88.851 62.98-145.671 66.722zm165.696-89.904c-25.969-34.85-41.338-76.771-44.204-120.586h88.998c-2.967 45.051-19.182 86.539-44.794 120.586z"}})])
          )
        }
      }
    